import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { BundleSliceModel } from '../models/bundle-slice.model'
import { produce } from 'immer'
import { BundleScheduleModel } from '../../../api/bundle/models/bundle-schedule.model'

const defaultState: BundleSliceModel = {
  showFilters: false,
  loading: true,
  pageNumber: 1,
  filters: {
    text: '',
    month: null,
  },
  data: [],
  selectedBundle: undefined,
  bundleHistory: {
    loading: false,
    data: [],
  },
  totalItemsCount: 0,
}

const initialState: BundleSliceModel = produce(defaultState, draft => draft)

const bundleSlice = createSlice({
  name: 'bundle',
  initialState,
  reducers: {
    toggleFiltersVisibility(state: BundleSliceModel) {
      state.showFilters = !state.showFilters
    },
    setFilters(state: BundleSliceModel, action: PayloadAction<BundleSliceModel['filters']>) {
      state.filters = action.payload
    },
    setLoading(state: BundleSliceModel, action: PayloadAction<boolean>) {
      state.loading = action.payload
    },
    setPageNumber(state: BundleSliceModel, action: PayloadAction<number>) {
      state.pageNumber = action.payload
    },
    setData(
      state: BundleSliceModel,
      action: PayloadAction<{ data: BundleSliceModel['data']; totalItemsCount: number }>
    ) {
      state.data = action.payload.data
      state.totalItemsCount = action.payload.totalItemsCount
    },
    setSelectedBundle(
      state: BundleSliceModel,
      action: PayloadAction<BundleSliceModel['selectedBundle']>
    ) {
      state.selectedBundle = action.payload

      if (!action.payload) {
        state.bundleHistory.data = []
      }
    },
    setSelectedBundleSchedules(
      state: BundleSliceModel,
      action: PayloadAction<BundleScheduleModel[]>
    ) {
      if (!state.selectedBundle) {
        return
      }

      state.selectedBundle.bundleSchedules = action.payload
    },
    updateSelectedBundleSchedule(
      state: BundleSliceModel,
      action: PayloadAction<{ schedule: BundleScheduleModel }>
    ) {
      if (!state.selectedBundle) {
        return
      }

      const index = state.selectedBundle.bundleSchedules.findIndex(
        schedule => schedule.id === action.payload.schedule.id
      )

      if (index === -1) {
        return
      }

      state.selectedBundle.bundleSchedules[index] = action.payload.schedule
    },
    setHistoryLoading(state: BundleSliceModel, action: PayloadAction<boolean>) {
      state.bundleHistory.loading = action.payload
    },
    setBundleHistory(
      state: BundleSliceModel,
      action: PayloadAction<BundleSliceModel['bundleHistory']['data']>
    ) {
      state.bundleHistory.data = action.payload
    },
    resetState() {
      return defaultState
    },
  },
})

export const bundleActions = bundleSlice.actions

export default bundleSlice
